import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const rows = [['⏰ 3-5 horas/semana buscando resúmenes y formatos en Google', '✅ 10 min/semana. El resto es estudiar con lo que ya tenés.'], ['😓 Siempre los mismos apuntes dispersos → llegás sin estar listo', '✅ Material completo y organizado → llegás preparado siempre'], ['💸 Materias que van a diciembre sin saber por qué', '✅ Sistema de simulacros → sabés exactamente qué repasar'], ['📋 Sin plantillas de planificación → entregas de última hora', '✅ 50+ plantillas listas → entregás en tiempo y forma'], ['😨 Práctica docente sin herramientas → pánico en la escuela', '✅ Kit completo de observación y registro → actuás con confianza'], ['👥 Anatomía y Fisiología sin un resumen útil → a diciembre', '✅ Guías visuales de las materias más difíciles → aprobás en tiempo'], ['📱 Sin sistema de estudio para orales', '✅ Guía completa de oratoria y comunicación docente'], ['💼 Sin identidad profesional visible en las prácticas', '✅ Sistema que te hace ver como el docente que querés ser']];
export function CostComparison() {
  return <section className="py-10 md:py-16 bg-gray-50 border-t border-gray-200" data-id="element-63">
      <div className="max-w-5xl mx-auto px-4" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-65">
          <h2 className="text-2xl md:text-4xl font-black text-brand-950 mb-2 md:mb-4" data-id="element-66">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </motion.div>

        {/* Mobile: stacked pair cards with arrow */}
        <div className="md:hidden space-y-2.5" data-id="element-67">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-68">
              <div className="px-3 py-2.5 bg-gray-50 border-b border-gray-100" data-id="element-69">
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-wider mb-1" data-id="element-70">
                  SIN PROFESORADO RESUELTO
                </p>
                <p className="text-[11px] text-gray-700 font-medium leading-snug" data-id="element-71">
                  {row[0]}
                </p>
              </div>
              <div className="px-3 py-2.5 bg-brand-50/50 relative" data-id="element-72">
                <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 w-5 h-5 bg-brand-600 rounded-full flex items-center justify-center shadow-md" data-id="element-73">
                  <ArrowRight className="w-3 h-3 text-white rotate-90" strokeWidth={3} data-id="element-74" />
                </div>
                <p className="text-[10px] font-black text-brand-600 uppercase tracking-wider mb-1 mt-1" data-id="element-75">
                  CON PROFESORADO RESUELTO
                </p>
                <p className="text-[11px] text-brand-900 font-bold leading-snug" data-id="element-76">
                  {row[1]}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Desktop: original table */}
        <div className="hidden md:block overflow-x-auto hide-scrollbar pb-4" data-id="element-77">
          <table className="w-full bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200 text-sm" data-id="element-78">
            <thead data-id="element-79">
              <tr data-id="element-80">
                <th className="py-5 px-6 text-left font-black text-gray-400 bg-gray-100 w-1/2 uppercase tracking-wider text-sm border-r border-gray-200" data-id="element-81">
                  SIN PROFESORADO RESUELTO
                </th>
                <th className="py-5 px-6 text-left font-black text-brand-900 bg-brand-100 w-1/2 uppercase tracking-wider text-sm" data-id="element-82">
                  CON PROFESORADO RESUELTO
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-83">
              {rows.map((row, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-84">
                  <td className="py-4 px-6 text-gray-600 font-medium border-r border-gray-100 bg-gray-50/30" data-id="element-85">
                    {row[0]}
                  </td>
                  <td className="py-4 px-6 font-bold text-brand-800 bg-brand-50/10" data-id="element-86">
                    {row[1]}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}